import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";

const InstutionalDefaulters = ({ formik }) => {
  const handleRadioChange = (value) => {
    formik.setValues({
      ...formik.values,
      reportingBasis: value,
    });
  };
  const handleDateChange = (value) => {
    formik.setValues({
      ...formik.values,
      loanMaturityDate: value,
    });
  };
  return (
    <div>
      <div className="mb-3">
        <CustomInput
          required
          label={"Name"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"name"}
          name={"name"}
          placeholder={"Enter name"}
          value={formik.values.name}
          error={formik.errors.name}
          touched={formik.touched.name}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          required
          label={"Address"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"address"}
          name={"address"}
          placeholder={"Enter address"}
          value={formik.values.address}
          error={formik.errors.address}
          touched={formik.touched.address}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          required
          label={"Registration Number"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"registrationNumber"}
          name={"registrationNumber"}
          placeholder={"Enter registrationNumber"}
          value={formik.values.registrationNumber}
          error={formik.errors.registrationNumber}
          touched={formik.touched.registrationNumber}
        />
      </div>
      {/* <div className="mb-3">
        <Label className="form-label" htmlFor="steparrow-gen-info-email-input">
          Registration Detail
        </Label>
        <select
          className="form-select"
          required
          placeholder="select"
          aria-label="select example"
        >
          <option value="1">Select</option>
          <option value="2">Bhaktapur</option>
          <option value="2">Lalitpur</option>
          <option value="2">Kathmandu</option>

         
        </select>
      </div>
      <div className="mb-3">
        <Label className="form-label" htmlFor="steparrow-gen-info-email-input">
          Spouse full name
        </Label>
        <Input
          type="text"
          className="form-control"
          id="steparrow-gen-info-email-input"
          placeholder="John Newman"
        />
      </div>
      <Row className="mt-4 bg-light py-2 mb-3">
        <Col xs={12} className="text-start">
          <span className="fw-bold px-3">Three Generation Details</span>
        </Col>
      </Row>

      <div className="mb-3">
        <Label className="form-label" htmlFor="steparrow-gen-info-email-input">
          Father full name
        </Label>
        <Input
          type="text"
          className="form-control"
          id="steparrow-gen-info-email-input"
          placeholder="John Newman"
        />
      </div>
      <div className="mb-3">
        <Label className="form-label" htmlFor="steparrow-gen-info-email-input">
          Grandfather full name
        </Label>
        <Input
          type="text"
          className="form-control"
          id="steparrow-gen-info-email-input"
          placeholder="John Newman"
        />
      </div> */}

      <Row className="mt-4 bg-light py-2 mb-3">
        <Col xs={12} className="text-start">
          <span className="fw-bold px-3">Loan Details</span>
        </Col>
      </Row>

      <div className="mb-3">
        <CustomInput
          required
          label={"Loan Amount"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"loanAmount"}
          name={"loanAmount"}
          placeholder={"Enter loanAmount"}
          value={formik.values.loanAmount}
          error={formik.errors.loanAmount}
          touched={formik.touched.loanAmount}
        />
      </div>
      <div className="mb-3">
        <Label for="loanMaturityDate">Loan Maturity Date</Label>
        <NepaliDatePicker
          inputClassName="form-control"
          className=""
          value={formik.values.loanMaturityDate}
          onChange={handleDateChange}
          options={{ calenderLocale: "en", valueLocale: "en" }}
        />
        {formik.errors.loanMaturityDate && formik.touched.loanMaturityDate && (
          <div className="text-danger">{formik.errors.loanMaturityDate}</div>
        )}
      </div>

      <Row>
        <span className="mb-1 mt-2 fw-bold">Reporting on basis of</span>
        <Col xs={4}>
          <FormGroup check>
            <Input
              name="radio2"
              type="radio"
              checked={formik.values.reportingBasis === "DueIntrest"}
              onChange={() => handleRadioChange("DueIntrest")}
            />{" "}
            <Label check>Due Interest</Label>
          </FormGroup>
        </Col>
        <Col xs={4}>
          <FormGroup check>
            <Input
              name="radio2"
              type="radio"
              checked={formik.values.reportingBasis === "DueInstallment"}
              onChange={() => handleRadioChange("DueInstallment")}
            />{" "}
            <Label check>Due Installment</Label>
          </FormGroup>
        </Col>
        <Col xs={4}>
          <FormGroup check>
            <Input
              name="radio2"
              type="radio"
              checked={formik.values.reportingBasis === "LoanOverDue"}
              onChange={() => handleRadioChange("LoanOverDue")}
            />{" "}
            <Label check>Loan Overdue</Label>
          </FormGroup>
        </Col>
        {formik.errors.reportingBasis && formik.touched.reportingBasis && (
          <div className="text-danger">{formik.errors.reportingBasis}</div>
        )}
      </Row>
    </div>
  );
};

export default InstutionalDefaulters;
